import { render, staticRenderFns } from "./ArticleMergeModal.vue?vue&type=template&id=70acdd58&"
import script from "./ArticleMergeModal.vue?vue&type=script&lang=js&"
export * from "./ArticleMergeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports